import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    },
    componentForm2: function componentForm2() {
      return import('./form2');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null, this.p('add') ? h("d2-bar-cell", [this.quickCreate()]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), h("component-form-2", {
      "ref": "form2",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DEVICE_UPDATE_ALL',
        delete: 'DEVICE_UPDATE_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '100px'
      }, {
        prop: 'new_version',
        label: this.$t('new_version'),
        minWidth: '100px'
      }, {
        prop: 'soft_url',
        label: this.$t('soft_url'),
        minWidth: '800px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("div", [" ", h("div", {
            "style": "color:green"
          }, ["\u7248\u672C\u53F7 ", row.new_version, " - ", row.soft_url]), " ", h("div", [" \u65E7\u7248\u672C\u53F7", row.old_version, " - ", row.old_soft_url])]);
        }
      }, // { prop: 'old_version', label: this.$t('old_version'), minWidth: '100px' },
      // { prop: 'old_soft_url', label: this.$t('old_soft_url'), minWidth: '160px' },
      {
        prop: 'status',
        label: this.$t('status'),
        minWidth: '100px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("div", [h("d2-dict", {
            "attrs": {
              "name": "device_update_status",
              "value": row.status
            }
          }), "-", row.status]);
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref3) {
        var row = _ref3.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.device_number);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.device_number);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: this.$t('device_number'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.device_number,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": ""
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.ctime,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "ctime", $$v);
              }
            }
          });
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": ""
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.uptime,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "uptime", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    quickCreate: function quickCreate() {
      var _this4 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "type": "primary",
          "icon": "el-icon-plus",
          "label": this.$t('batch_update_device')
        },
        "on": {
          "click": function click() {
            return _this4.create({}, 'form2');
          }
        }
      });
      return node;
    }
  })
};